import { render, staticRenderFns } from "./SantaHat.vue?vue&type=template&id=49320395&scoped=true"
import script from "./SantaHat.vue?vue&type=script&lang=js"
export * from "./SantaHat.vue?vue&type=script&lang=js"
import style0 from "./SantaHat.vue?vue&type=style&index=0&id=49320395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49320395",
  null
  
)

export default component.exports